
import React from "react";
import { Button } from "@/components/ui/button";

interface TimeRangeSelectorProps {
  value: 'week' | 'month' | 'quarter' | 'year';
  onChange: (value: 'week' | 'month' | 'quarter' | 'year') => void;
}

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <div className="flex items-center space-x-2 mb-6">
      <span className="text-sm text-muted-foreground">Time Range:</span>
      <div className="flex space-x-1">
        <Button 
          size="sm" 
          variant={value === 'week' ? 'default' : 'outline'}
          onClick={() => onChange('week')}
        >
          Week
        </Button>
        <Button 
          size="sm" 
          variant={value === 'month' ? 'default' : 'outline'}
          onClick={() => onChange('month')}
        >
          Month
        </Button>
        <Button 
          size="sm" 
          variant={value === 'quarter' ? 'default' : 'outline'}
          onClick={() => onChange('quarter')}
        >
          Quarter
        </Button>
        <Button 
          size="sm" 
          variant={value === 'year' ? 'default' : 'outline'}
          onClick={() => onChange('year')}
        >
          Year
        </Button>
      </div>
    </div>
  );
}
